<script lang="ts">
	export let items: string[] = [];
	export let speed: number = 20; // seconds for one full cycle
	export let direction: 'left' | 'right' = 'left';
	export let pauseOnHover: boolean = true;
	export let gap: number = 3; // gap between items in rem (not px)
</script>

<div class="marquee-container" class:pause-on-hover={pauseOnHover}>
	<div 
		class="marquee-track" 
		style="--speed: {speed}s; --direction: {direction === 'left' ? '-100%' : '100%'}; --gap: {gap}rem;"
	>
		<div class="marquee-content">
			{#each items as item}
				<span class="marquee-item">{item}</span>
			{/each}
		</div>
		<!-- Duplicate for seamless loop -->
		<div class="marquee-content" aria-hidden="true">
			{#each items as item}
				<span class="marquee-item">{item}</span>
			{/each}
		</div>
	</div>
</div>

<style>
	.marquee-container {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		background: transparent;
	}
	
	.marquee-track {
		display: flex;
		width: fit-content;
		animation: marquee var(--speed) linear infinite;
	}
	
	.marquee-content {
		display: flex;
		align-items: center;
		gap: var(--gap);
		min-width: max-content;
	}
	
	.marquee-item {
		flex-shrink: 0;
		white-space: nowrap;
		font-size: 5rem; /* 80px (16*5) - Responsive และ Accessible */
		font-weight: 700;
		color: #fff;
		text-transform: uppercase;
		letter-spacing: 0.125rem; /* 2px equivalent - ใช้ rem สัมพันธ์กับฟอนต์ */
		font-family: inherit;
		line-height: 1.2; /* ใช้ unitless เพื่อ responsive */
	}
	
	/* Pause animation on hover */
	.pause-on-hover:hover .marquee-track {
		animation-play-state: paused;
	}
	
	@keyframes marquee {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(var(--direction));
		}
	}
	
	/* Responsive adjustments */
	@media (max-width: 1200px) {
		.marquee-item {
			font-size: 4rem; /* 64px - ลดลงเป็นสัดส่วน */
		}
	}
	
	@media (max-width: 768px) {
		.marquee-item {
			font-size: 3rem; /* 48px - มือถือ */
			letter-spacing: 0.1rem; /* ลด letter-spacing ตามขนาดฟอนต์ */
		}
	}
	
	@media (max-width: 480px) {
		.marquee-item {
			font-size: 2rem; /* 32px - มือถือเล็ก */
			letter-spacing: 0.05rem; /* ปรับให้เหมาะสม */
		}
	}
</style>
